export default "__VITE_ASSET__Bt1yeMMU__"